import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';
import router from '../../../router/router';

let localSubscription = undefined;

function createSubscription(store) {
	let diagnoseQuery = new Parse.Query('MedicationDiagnosis');
	diagnoseQuery.notEqualTo("deleted", true)
	diagnoseQuery.find()
		.then((results) => {
			store.dispatch('diagnoses/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		diagnoseQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('diagnoses/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('diagnoses/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('diagnoses/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('diagnoses/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('diagnoses/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}

export default function createDiagnoseSubscription() {
	return store => {
		store.subscribe(mutation => {
			//1: Check - Wird die richtige Mutation ausgelöst? Diese wird im Router bei jedem Routing-Vorgang ausgelöst.
			if (mutation.type === 'ADD_LAST_ROUTE') {
				//2: Check - Bin ich aktuell in der Medikation?
				if (router.currentRoute.name == "Medication" || router.currentRoute.name == "MedicationEntry") {
					//3: Check - Prüfe, ob bereits eine lokale Subscription vorliegt.
					if (!localSubscription) {
						createSubscription(store)
					}
				}
			}
		})
	}
}
